import type { AfterViewInit, OnInit } from '@angular/core';
import {
    Component,
    ContentChild,
    ElementRef,
    HostBinding,
    Input,
    Renderer2,
    RendererStyleFlags2,
    ViewChild,
} from '@angular/core';
import { PageHeaderComponent } from '@shared/common/layout/page-header/page-header.component';

@Component({
    selector: 'app-page-layout',
    templateUrl: './page-layout.component.html',
    styleUrls: ['./page-layout.component.scss'],
})
export class PageLayoutComponent implements OnInit, AfterViewInit {
    @ViewChild('container') containerRef: ElementRef;
    @ContentChild(PageHeaderComponent) headerContent!: PageHeaderComponent;

    @Input() set width(value: number) {
        this._width = value;

        this.updateWidth();
    }

    @Input() set centered(value: boolean) {
        this._centered = value;

        this.updateWidth();
    }

    @Input() fitHeight = false;

    private _width: number;
    private _centered = true;

    @HostBinding('class.has-header') get hasHeader(): boolean {
        return !!this.headerContent;
    }

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    ngOnInit(): void {
        this.updateWidth();
    }

    ngAfterViewInit(): void {
        this.updateWidth();
    }

    private updateWidth(): void {
        if (!this.containerRef) {
            return;
        }

        if (this._width) {
            this.renderer.setStyle(
                this.elementRef.nativeElement,
                '--page-max-width',
                `${this._width}px`,
                RendererStyleFlags2.DashCase
            );
            this.renderer.setStyle(this.containerRef.nativeElement, 'max-width', `${this._width}px`);
            if (this._centered) {
                this.renderer.setStyle(this.containerRef.nativeElement, 'margin', '0 auto');
            }
        } else {
            this.renderer.removeStyle(this.containerRef.nativeElement, '--page-max-width');
            this.renderer.removeStyle(this.containerRef.nativeElement, 'max-width');
            this.renderer.removeStyle(this.containerRef.nativeElement, 'margin');
        }
    }
}
